// extracted by mini-css-extract-plugin
export default {"table":"style_table__1VpZG","tableCellHead":"style_tableCellHead__zBmL2","tableCell":"style_tableCell__M+aEp"};